import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { GlobalService } from "../global-service";
import { MessageService } from "primeng/api";

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css']
})
export class GalleryComponent implements OnInit {
  gallery: any = [];
  FilterPhoto: any;

  constructor(
    private router: Router,
    public global: GlobalService,
    private route: ActivatedRoute,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.getGallery();
  }

  getGallery() {
    const url = this.global.basePath + "common/circularlist?modelType=photo";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      this.FilterPhoto = data;
      console.log("🚀 ~ file: gallery.component.ts ~ line 31 ~ GalleryComponent ~ this.global.GetRequestUnauthorised ~ this.FilterPhoto", this.FilterPhoto)
      // this.FilterPhoto = this.gallery.slice(3);
    });
  }

}
